import { TOKEN_PATTERN, type TranslationKey } from "../api/translationKeys";

/**
 * Frontend mirror of backend/utils/resolveTranslationTokens.js — identical
 * algorithm. Substitutes every {{key}} token in `text` using
 * `translationsByKey` for `lang`, falling back to `fallbackLang`. Tokens that
 * can't be resolved in either language are left as raw {{key}} text and
 * reported in missingKeys.
 */
export function resolveTranslationTokens(
  text: string,
  translationsByKey: Record<string, TranslationKey["translations"]>,
  lang: string,
  fallbackLang: string
): { resolved: string; missingKeys: string[] } {
  if (typeof text !== "string" || text.length === 0) {
    return { resolved: text ?? "", missingKeys: [] };
  }

  const missingKeys: string[] = [];

  const resolved = text.replace(TOKEN_PATTERN, (match, keyName) => {
    const entry = translationsByKey?.[keyName];
    const primary = entry?.[lang as keyof TranslationKey["translations"]];
    if (primary) return primary;

    const fallback = fallbackLang !== lang ? entry?.[fallbackLang as keyof TranslationKey["translations"]] : null;
    if (fallback) return fallback;

    missingKeys.push(keyName);
    return match;
  });

  return { resolved, missingKeys };
}
